module.exports = __webpack_public_path__ + "a4d7856cfe32fe9465d1d76872e34a90.svg";